//
// Login:
//

export const index = {
    path   : '/profit_sharings/',
    method : 'GET',
    version: '/v1'
}

export const getItem = {
  path   : '/profit_sharings/:profit_sharing_id/',
  method : 'GET',
  version: '/v1'
}

export const addItem = {
  path   : '/profit_sharings/',
  method : 'POST',
  version: '/v1'
}

export const updateItem = {
  path   : '/profit_sharings/:profit_sharing_id/',
  method : 'POST',
  version: '/v1'
}

export const deleteItem = {
  path   : '/profit_sharings/:profit_sharing_id/',
  method : 'DELETE',
  version: '/v1'
}
